module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAATRJREFUSEvt0iFPxTAQB/C7ZSOBBDEUDo3C8hIcCgNqfmztLOGLEDQ9kqJHEBgUCsSzKCwSxRyQjfRIE56Bl219e/AS0qolvbtf878hLOjgglzw8J8l76P2Uf9aAv7n+hFtkiTLcRxfMPMBIi61Zc/MNQBcNU1zqLV+b6vtjFpKeYSIpy7LZuZCKaUGwUVRHAPAiQtsjBFEdD4IzrJsNQzDOwDY6ok/VFU1KsvybRBsm9M0XY+iaIyIGx34U13XI631c9cjO3c8GSCE2ETEe0RcmzaUmV+YeYeIHrtQe98btsVCiO0gCG4BYOXb8FdjzC4RjfugzrBtkFLuIeI1AIRfyAcz7yulbvqiM8G2Kc/zJAiCM/vNzJKILl3QmWFXZFq9047nAU5meHieabbO8lH//6g/AVBZWB+MQ1gXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/digitalHuman/assets/images/arrow-down.png
// module id = gvWR
// module chunks = 17